import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import {
  DEFAULT_RUN_DETAIL_TAB,
  RUN_DETAIL_TABS,
  type RunDetailTab,
} from '~/features/deliveries/constants/tabs';

const DeliveryRunDetailPage = lazy(
  () => import('~/features/deliveries/pages/delivery-run-detail-page'),
);

export const Route = createFileRoute('/_authenticated/_tenant/deliveries/$runId')({
  /** `tab` selects the workspace panel; `node` deep-links a work-unit tree node. */
  validateSearch: (search: Record<string, unknown>): { tab: RunDetailTab; node?: string } => {
    const tab = RUN_DETAIL_TABS.includes(search.tab as RunDetailTab)
      ? (search.tab as RunDetailTab)
      : DEFAULT_RUN_DETAIL_TAB;
    const node = typeof search.node === 'string' ? search.node : undefined;
    return node !== undefined ? { tab, node } : { tab };
  },
  component: RouteComponent,
});

/** Bridges the route's path/search params into the run-workspace page props. */
function RouteComponent() {
  const { runId } = Route.useParams();
  const { tab, node } = Route.useSearch();
  return (
    <Suspense fallback={<PageSkeleton />}>
      <DeliveryRunDetailPage runId={runId} tab={tab} node={node} />
    </Suspense>
  );
}
